module.exports = __webpack_public_path__ + "static/media/logo_login1.0766bf94.png";